export const isLanguageSupported = (language: string, supportedLanguages: string[]): boolean =>
    supportedLanguages.includes(language);

/**
 * Get the language to use from the browser language according to the supported languages in the application.
 * Exemple 1:
 *  - The browser language is "en-US"
 *  - "en-US" is in supportedLanguages, language will be "en-US"
 * Exemple 2:
 *  - The browser language is "en-US"
 *  - "en-US" is NOT in supportedLanguages, but "en" is. Language will be "en"
 * Exemple 3:
 *  - The browser language is "en-US"
 *  - "en-US" is NOT in supportedLanguages, and "en" neither. Language will be fallbackLanguage.
 */
export const getLanguageFromSupported = (
    language: string,
    supportedLanguages: string[],
    fallbackLanguage: string
): string => {
    if (isLanguageSupported(language, supportedLanguages)) {
        return language;
    }
    else {
        const [languageOnly] = language.split("-");
        return isLanguageSupported(languageOnly, supportedLanguages) ? languageOnly : fallbackLanguage;
    }
};